import { createContext, useContext, useMemo, useState } from "react";
import { useCurrentUser } from "../../UserProvider";

const ArtistContext = createContext({});

export function useArtistContext() {
  return useContext(ArtistContext);
}

export default function ArtistPageContext({ children, artist: initialArtist }) {
  const { currentUser } = useCurrentUser();
  const [artist, setArtist] = useState(initialArtist);

  const isOwner = useMemo(() => {
    return currentUser && artist && currentUser.id === artist.user_id;
  }, [currentUser, artist]);

  return (
    <ArtistContext.Provider value={ { isOwner, artist, setArtist } }>
      { children }
    </ArtistContext.Provider>
  );
}
